import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { PlatformApp } from "@taunggyi-plus/app-shell";
import { AuthProvider } from "@taunggyi-plus/auth";
import { getAppConfig, installPageZoomLock } from "@taunggyi-plus/config";
import { DeliveryOwnerMore, CustomerInformationDialog } from "@taunggyi-plus/customer-feature";
import "@taunggyi-plus/design-system/styles.css";
import { DirectDeliveryOrders, DeliveryOwnerDispatch } from "@taunggyi-plus/delivery-feature";
import { FinanceOverview, PartnerPromotionRequests } from "@taunggyi-plus/finance-feature";
import { NotificationCenter } from "@taunggyi-plus/notifications";
import { PartnerApplication } from "@taunggyi-plus/onboarding-feature";

const authConfig = {
  appId: "delivery-owner",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

function DeliveryOwnerDashboard({ locale }: { readonly locale: "en" | "my" | "shn" | "zh" }) {
  return (
    <div className="role-dashboard role-dashboard--delivery-owner">
      <PartnerApplication locale={locale} kind="delivery_fleet" />
      <DeliveryOwnerDispatch view="dashboard" />
    </div>
  );
}

function DeliveryRiderList() {
  return (
    <div className="role-workspace role-workspace--delivery-riders">
      <DeliveryOwnerDispatch view="riders" />
      <PartnerPromotionRequests providerKind="delivery" />
    </div>
  );
}

function DeliveryOrders() {
  return (
    <div className="role-workspace role-workspace--delivery-orders">
      <DirectDeliveryOrders provider />
      <DeliveryOwnerDispatch view="orders" />
    </div>
  );
}

installPageZoomLock();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <PlatformApp
        config={getAppConfig("delivery-owner")}
        informationContent={(locale, id, onClose) => (
          <CustomerInformationDialog locale={locale} id={id} onClose={onClose} />
        )}
        navigationMode="owner"
        dashboardContent={(locale) => <DeliveryOwnerDashboard locale={locale} />}
        myServicesLabel="Rider List"
        myServicesPath="/riders"
        myServicesContent={<DeliveryRiderList />}
        ordersContent={<DeliveryOrders />}
        financeContent={<FinanceOverview role="delivery" />}
        moreContent={(locale, onLocaleChange, onOpenPreferences) => (
          <DeliveryOwnerMore
            locale={locale}
            onLocaleChange={onLocaleChange}
            onOpenPreferences={onOpenPreferences}
          />
        )}
        notificationContent={(locale) => (
          <NotificationCenter
            locale={locale}
            appId="delivery-owner"
            embedded
            webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
          />
        )}
      />
    </AuthProvider>
  </StrictMode>,
);
